<mat-card class="loren-card mb-3 {{ look }}">
  <ng-content select="[titleTemplate]"></ng-content>
  <ng-content select="[subTitleTemplate]"></ng-content>
  @if (title) {
    <mat-card-header class="loren-card-header">
      @if (imgSrc) {
        <img mat-card-avatar [src]="imgSrc" [alt]="title" />
      }
      @if (iconName) {
        <mat-icon
          mat-card-avatar
          class="loren-card-icon"
          [color]="iconColor"
          >{{ iconName }}</mat-icon
          >
        }
        @if (title) {
          <mat-card-title class="loren-card-title">
            {{ title | transloco : translationOptions }}
          </mat-card-title>
        }
        @if (subTitle) {
          <mat-card-subtitle class="loren-card-subtitle">
            {{ subTitle | transloco : translationOptions }}
          </mat-card-subtitle>
        }
      </mat-card-header>
    }
    <mat-card-content class="loren-card-content">
      <ng-content></ng-content>
    </mat-card-content>
    <mat-card-actions>
      <ng-content select="[actionsTemplate]"></ng-content>
    </mat-card-actions>
  </mat-card>
